import React from 'react';
import Flex from './Flex';
import Text from './Text';
import styled from 'styled-components';
import { qs } from '../lib';

const Container = styled(Flex)`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #373737;
    align-items: center;
    justify-content: center;
`;

const Logout = ({ signOut }) => {
    setTimeout(() => signOut(), 1000);

    const { error } = qs.parse(window.location.search);

    return (
        <Container>
            {error ? <Text>Your username or password were entered incorrectly.</Text> : null}
            <Text>You are being logged out.</Text>
        </Container>
    );
};

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout.js